<div class="embedded-video-player">
  <div class="video-container" [ngClass]="{ hidden: !playerReady() }">
    @if (platform() === EPlatform.twitch) {
      <app-twitch-player
        [videoUrl]="videoUrl()"
        [autoPlay]="autoPlay()"
        (playerStateChange)="updatePlayerState($event.isPlaying, $event.currentTime, $event.duration)"
        (playerReady)="playerReady.set(true)"
      />
    }
    @if (platform() === EPlatform.youtube) {
      <app-youtube-player
        [videoUrl]="videoUrl()"
        [autoPlay]="autoPlay()"
        (playerStateChange)="updatePlayerState($event.isPlaying, $event.currentTime, $event.duration)"
        (playerReady)="playerReady.set(true)"
      />
    }
  </div>

  @if (!playerReady()) {
    <div class="bg-white">
      <app-skeleton-loader
        containerClass=""
        [columns]="skeletonVideoColumns"
        [rows]="skeletonVideoRows"
        [showColumns]="false"
        [showPaginator]="false"
      />
    </div>
  }
</div>
